import { useEffect } from 'react';
import { useRootSelector } from '@repo/mfe-core';

import { useAgentContext } from '../../app/contexts/AgentContext';

export function useSyncWithHostStore() {
  const { updateAgentState } = useAgentContext();

  // Get isMenuPinned from the global state
  const isMenuPinned = useRootSelector((state) => state.user?.isMenuPinned);

  // Get globalDateFormat from the global state
  const globalDateFormat = useRootSelector(
    (state) => state.user?.headerMenu?.ecmDateFormat
  );

  // Sync context state with Redux state
  useEffect(() => {
    updateAgentState('isMenuPinned', isMenuPinned ?? false);
  }, [isMenuPinned, updateAgentState]);

  useEffect(() => {
    updateAgentState('globalDateFormat', globalDateFormat ?? 'MMM dd, yyyy');
  }, [globalDateFormat, updateAgentState]);
}
